
export default class JsonUtil {
  static jsonToObject<T>(Type: { new(): T }, data: Record<string, unknown>): T {
    let obj: T = new Type()
    const snakeToCamel = (n: string) => {
      return n.replace(/_./g, (s: string) => s.charAt(1).toUpperCase())
    }
    const ents: [string, unknown][] = Object.entries(data)
    for (const [key, value] of ents) {
      const camelKey = snakeToCamel(key)
      obj = Object.assign(obj, { [camelKey]: value })
    }
    return obj
  }

  static objectToJson<T>(data: T, properties: string[]): Record<string, unknown> {
    let obj = {}
    const camelToSnake = (n: string) => {
      return n.replace(/[A-Z]/g, (s: string) => '_' + s.toLowerCase())
    }
    const ents: [string, unknown][] = Object.entries(data)
    for (const [key, value] of ents) {
      const camelKey = camelToSnake(key)
      if (properties.indexOf(camelKey) >= 0) {
        obj = Object.assign(obj, { [camelKey]: value })
      }
    }
    return obj
  }
}
